
const useCsvConverter = () => {
    const convertToCsv = (rows) => {
        if (!rows || rows.length === 0) {
            return "";
        }

        const headers = Object.keys(rows[0]);
        const csvRows = [];
        csvRows.push(headers.join(","));

        rows.forEach((row) => {
            const values = headers.map((h) => {
                let value = row[h];

                if ((h === "createdAt" || h === "updatedAt") && value) {
                    const date = new Date(value);
                    value = date.toLocaleString("en-IN", { hour12: true });
                }

                return JSON.stringify(value ?? "");
            });

            csvRows.push(values.join(","));
        });

        return csvRows.join("\n");
    };

    return { convertToCsv };
};

export default useCsvConverter;